import { Observable } from 'rxjs/Rx';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { environment } from '../../environments/environment';
import { Color, ProjectImage, VisualizerResponse, VisualizerStateReady } from '../models/color.model';
import { StartupService } from './startup.service';



@Injectable()
export class VisualizerService {
  public visualizerData: VisualizerResponse;

  private readonly site = this.startupService.websiteName;

  private selectedColorSource = new BehaviorSubject<Color>(null);
  selectedColor = this.selectedColorSource.asObservable();

  private readySource = new BehaviorSubject<VisualizerStateReady>(new VisualizerStateReady);
  isReady = this.readySource.asObservable();

  private zoomStateSource = new BehaviorSubject<boolean>(true);
  zoomState = this.zoomStateSource.asObservable();

  private _currentProject: ProjectImage;
  get currentProject(): ProjectImage {
    return this._currentProject;
  }
  set currentProject(projectImage: ProjectImage) {
    this._currentProject = projectImage;
  }

  setSelectedColor(color: Color) {
    this.selectedColorSource.next(color);
  }

  setVisualizerState(state: VisualizerStateReady) {
    this.readySource.next(state);
  }

  setZoomState(hide: boolean) {
    this.zoomStateSource.next(hide);
  }

  constructor(
    private http: HttpClient,
    private startupService: StartupService
  ) { }

  getVisualizerData(opacities: string[], projectId: string, woodGrain: string, woodType: string): Observable<VisualizerResponse> {
    let queryString: HttpParams = new HttpParams();
    queryString = queryString.append('woodGrain', woodGrain);
    queryString = queryString.append('projectId', projectId);
    queryString = queryString.append('woodType', woodType);
    for (const opacity of opacities) {
      queryString = queryString.append('opacity', opacity);
    }
    return this.http
      .get<VisualizerResponse>(
        `${environment.apiUrl}/visualizer/${this.site}/${window.location.href.split('/')[3]}`,
        { params: queryString });
  }
  detectIEBrowser(): boolean {
    const ua = window.navigator.userAgent;

    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return true;
    }

    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      const rv = ua.indexOf('rv:');
      return true;
    }

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/visualizer.service.ts